'use strict';

var _ = require('lodash');
var FeatureToggleService = function FeatureToggleService() {
  var features = {};
  function initialize(featuresObj) {
    features = featuresObj;
  }
  function isFeatureEnabled(feature) {
    return !!features[feature];
  }
  function isFeatureDisabled(feature) {
    return !features[feature];
  }
  function parseExpression(expression) {
    /*
    How this is working:
     This is working to add more complexity for grouping in or and and to separate in subgroups.
    '&&' and '||' is breaking the expression in two subgroups and parse as separate subgroups.
      Operators Precedence:
      &&: And subgroups.
     ||: Or subgroups.
     ;: And operator
     ,: Or operator
      Examples:
      A;B = A && B
     A,B = A || B
      A&&B = (A) && (B)
     A||B = (A) || (B)
      A,B||C;D = (A || B) || (C && D)
      A,B||C,D&&A;Z = ( (A||B) || (C||D) ) && ( A && Z )
     */

    expression = expression.replace(/\s/g, '');
    if (_.includes(expression, '&&')) {
      return {
        $and: _.map(parseExpressionWith(expression, '&&'), parseExpression)
      };
    } else if (_.includes(expression, '||')) {
      return {
        $or: _.map(parseExpressionWith(expression, '||'), parseExpression)
      };
    } else if (_.includes(expression, ';')) {
      return {
        $and: _.map(parseExpressionWith(expression, ';'), parseExpression)
      };
    } else if (_.includes(expression, ',')) {
      return {
        $or: _.map(parseExpressionWith(expression, ','), parseExpression)
      };
    }
    return expression;
  }
  function parseExpressionWith(expression, token) {
    return expression.split(token);
  }
  function evaluateFrom(parsedExpression, evalFeature) {
    if (_.isString(parsedExpression)) {
      return evalFeature.call(undefined, parsedExpression);
    }
    if (_.has(parsedExpression, '$or')) {
      return _.reduce(parsedExpression.$or, function (acc, value) {
        return acc || evaluateFrom(value, evalFeature);
      }, false);
    }
    if (_.has(parsedExpression, '$and')) {
      return _.reduce(parsedExpression.$and, function (acc, value) {
        return acc && evaluateFrom(value, evalFeature);
      }, true);
    }
  }
  function isEnabled(expression) {
    var groupExpression = parseExpression(expression);
    return evaluateFrom(groupExpression, isFeatureEnabled);
  }
  function isDisabled(expression) {
    var groupExpression = parseExpression(expression);
    return evaluateFrom(groupExpression, isFeatureDisabled);
  }
  function isEnabledBasedOnConfig(config) {
    var isValid = true;
    if (config.ifFeatureEnabled) {
      if (_.isArray(config.ifFeatureEnabled)) {
        isValid = isEnabled(config.ifFeatureEnabled.join(';'));
      } else {
        isValid = isEnabled(config.ifFeatureEnabled);
      }
    }
    if (config.ifFeatureDisabled) {
      if (_.isArray(config.ifFeatureDisabled)) {
        isValid = isValid && isDisabled(config.ifFeatureDisabled.join(';'));
      } else {
        isValid = isValid && isDisabled(config.ifFeatureDisabled);
      }
    }
    return isValid;
  }
  return {
    initialize: initialize,
    isEnabled: isEnabled,
    isDisabled: isDisabled,
    isEnabledBasedOnConfig: isEnabledBasedOnConfig
  };
};
FeatureToggleService.$inject = [];
module.exports = FeatureToggleService;